module.exports = __webpack_public_path__ + "img/qi-logo-branco.ac152fd7.svg";